// extracted by mini-css-extract-plugin
export default {"button":"Button_button__5FFiC","button--active":"Button_button--active__4sXtT"};